import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c771131"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"background-color":"#eceff7"} }
const _hoisted_2 = { style: {"padding":"0px 10px 20px 10px"} }
const _hoisted_3 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "资源开单数", -1))
const _hoisted_5 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "资源开单均价", -1))
const _hoisted_7 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当月开单数", -1))
const _hoisted_9 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "当月开单均价", -1))
const _hoisted_11 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_12 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_13 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart3",
  style: { width: '100%', height: '400px', backgroundColor: 'white' }
}, null, -1))
const _hoisted_15 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_16 = { style: {"font-weight":"bold","font-size":"xxx-large"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "myChart4",
  style: { width: '100%', height: '400px', backgroundColor: 'white' }
}, null, -1))

import { onMounted, ref } from 'vue'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import localCache from '@/utils/cache'
import { ElLoading } from 'element-plus'
import type { FormInstance } from 'element-plus'
import * as echarts from 'echarts'
import {
  getresourceTrans,
  getResourceChat
} from '@/service/main/inspect/ResourceAnalysis'

export default /*#__PURE__*/_defineComponent({
  __name: 'ResourceTransChat',
  setup(__props) {

const store = useStore()
// 格式化两位小数百分比
const formatToPercentage = (number: any) => {
  // 将数字转换为百分比并保留两位小数
  const percentage = (number * 100).toFixed(2);
  return `${percentage}%`;
}
const shortcuts = [
  {
    text: '最近7天',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setDate(start.getDate() - 7)
      return [start, end]
    }
  },
  {
    text: '最近1个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 1)
      return [start, end]
    }
  },
  {
    text: '最近3个月',
    value: () => {
      const end = new Date()
      const start = new Date()
      start.setMonth(start.getMonth() - 3)
      return [start, end]
    }
  }
]
const formRef = ref<FormInstance>(null);
const queryParam = ref({
  timeSlot: ref<[string, string]>([
    dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
    dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
  ]),
  deptId: ref(''),
  empName: ref('')
})

const handleResetClick = () => {
  queryParam.value = {
    timeSlot: [
      dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ],
    deptId: '',
    empName: ''
  };
}

const resourceCount = ref(0)
const dealCount = ref(0)
const avgPrice = ref(0)
const currentMonthDealCount = ref(0)
const currentMonthAvgPrice = ref(0)
const chatCount = ref(0)
const chatRate = ref(0)
const chatDealCount = ref(0)
const totalBillingDealRate = ref(0)
const totalResourceDealRate = ref(0)

const initData = async () => {
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '统计数据中...',
    background: 'rgba(0, 0, 0, 0.7)'
  })
  const [data1, data3] = await Promise.allSettled([
    getresourceTrans(queryParam.value),
    getResourceChat(queryParam.value)
  ])
  loadingInstance.close()
  if (data1.status == 'fulfilled') {
    resourceCount.value = data1.value.resourceCount
    dealCount.value = data1.value.dealCount
    avgPrice.value = data1.value.avgPrice1
    currentMonthDealCount.value = data1.value.currentMonthDealCount
    currentMonthAvgPrice.value = data1.value.currentMonthAvgPrice1
  } else {
    resourceCount.value = 0
    dealCount.value = 0
    avgPrice.value = 0
    currentMonthDealCount.value = 0
    currentMonthAvgPrice.value = 0
  }
  if (data3.status == 'fulfilled') {
    chatCount.value = data3.value.chatCount
    chatRate.value = data3.value.chatRate
    chatDealCount.value = data3.value.chatDealCount
    totalBillingDealRate.value = data3.value.totalBillingDealRate
    totalResourceDealRate.value = data3.value.totalResourceDealRate
    if (myChart3) { // 确保图表已初始化
      myChart3.setOption({ // 更新图表配置项中的数据部分
        series: [{ data: [{ value: data3.value.countA, name: 'A类客户' }, { value: data3.value.countB, name: 'B类客户' }, { value: data3.value.countC, name: 'C类客户' }, { value: data3.value.countD, name: 'D类客户' }] }]
      });
    }
    if (myChart4) { // 确保图表已初始化
      myChart4.setOption({ // 更新图表配置项中的数据部分
        series: [{ data: [{ value: data3.value.chatDealCountA, name: 'A类客户' }, { value: data3.value.chatDealCountB, name: 'B类客户' }, { value: data3.value.chatDealCountC, name: 'C类客户' }, { value: data3.value.chatDealCountD, name: 'D类客户' }] }]
      });
    }
  } else {
    chatCount.value = 0
    chatRate.value = 0
    chatDealCount.value = 0
    totalBillingDealRate.value = 0
    totalResourceDealRate.value = 0
    if (myChart3) {
      myChart3.setOption(option3)
    }
    if (myChart4) {
      myChart4.setOption(option4)
    }
  }
}

const onSubmit = async (formRef: FormInstance) => {
  if (!formRef) return
  await formRef.validate((valid, fields) => {
    if (valid) {
      console.log('校验成功')
      initData()
    } else {
      console.log('校验失败')
    }
  })
}
let myChart3 = null;
let myChart4 = null;

const option3 = {
  tooltip: {
    formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
  },

  title: {
    text: '分类上表数',
    left: 'center',
    // top: '6%', // 标题距离容器顶部2%的位置
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: 'A类客户'
        },
        {
          value: 0,
          name: 'B类客户'
        },
        {
          value: 0,
          name: 'C类客户'
        },
        {
          value: 0,
          name: 'D类客户'
        }
      ],
      radius: '75%',
      label: {
        show: true, // 显示所有标签
        position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
        formatter: '{b}:{d}%' // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
      },
      labelLine: {
        show: false // 不显示连接线
      }
    }
  ]
}
const option4 = {
  tooltip: {
    formatter: '{b}: {c}' // {a}: 系列名, {b}: 数据名, {c}: 数据值
  },

  title: {
    text: '分类成交数',
    left: 'center',
    // top: '6%', // 标题距离容器顶部2%的位置
  },
  series: [
    {
      type: 'pie',
      data: [
        {
          value: 0,
          name: 'A类客户'
        },
        {
          value: 0,
          name: 'B类客户'
        },
        {
          value: 0,
          name: 'C类客户'
        },
        {
          value: 0,
          name: 'D类客户'
        }
      ],
      radius: '75%',
      label: {
        show: true, // 显示所有标签
        position: 'inside', // 或者'outside', 'inside', 'top', 'left', 'right', 'bottom'
        formatter: '{b}:{d}%' // 格式化标签内容，{b}是名称，{c}是值，{d}%是占比
      },
      labelLine: {
        show: false // 不显示连接线
      }
    }
  ]
}

onMounted(() => {
  initData()
  myChart3 = echarts.init(document.getElementById('myChart3'))
  myChart3.setOption(option3)
  myChart4 = echarts.init(document.getElementById('myChart4'))
  myChart4.setOption(option4)

  window.addEventListener('resize', function () {
    myChart3.resize();
  });
  window.addEventListener('resize', function () {
    myChart4.resize();
  });
})
const rules = {
  timeSlot: [{
    required: true,
    message: '加入时间必填',
    trigger: 'change',
  }],
}

const userOptions = localCache.getCache('empData').map((item: any) => {
  return { title: item.realName, value: item.realName }
})

const deptOptions = store.state.login.depts.map((item: any) => {
  return { title: item.name, value: item.id }
})


return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref_key: "formRef",
      ref: formRef,
      inline: true,
      model: queryParam.value,
      class: "demo-form-inline",
      rules: rules,
      style: {"padding":"10px 0 0","background-color":"#fff"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "组别" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: queryParam.value.deptId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryParam.value.deptId) = $event)),
                      placeholder: "请选择组别",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deptOptions), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.title,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 4 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      onClick: handleResetClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("重置")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onSubmit(formRef.value)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("搜索")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 5 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg,rgba(145, 204, 117, 1), rgba(145, 204, 117, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(dealCount.value), 1),
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 5,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(250, 200, 88, 1), rgba(250, 200, 88, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(avgPrice.value), 1),
                  _hoisted_6
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 5,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg,rgba(145, 204, 117, 1), rgba(145, 204, 117, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(currentMonthDealCount.value), 1),
                  _hoisted_8
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 5,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(250, 200, 88, 1), rgba(250, 200, 88, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, _toDisplayString(currentMonthAvgPrice.value), 1),
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 7 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(60, 120, 100, 1), rgba(60, 120, 100, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("上表资源数"),
                    _createElementVNode("span", _hoisted_11, _toDisplayString(chatCount.value), 1),
                    _createTextVNode("（" + _toDisplayString(chatRate.value) + "%）", 1)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(84, 112, 198, 1), rgba(84, 112, 198, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("资源总数"),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(resourceCount.value), 1),
                    _createTextVNode("（个）")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(60, 120, 100, 1), rgba(60, 120, 100, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("在表开单数"),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(chatDealCount.value), 1),
                    _createTextVNode("（个）")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 7 }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(238, 102, 102, 1), rgba(238, 102, 102, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("在表开单率"),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(totalBillingDealRate.value), 1),
                    _createTextVNode("%")
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, {
                class: "box-card",
                style: {"background":"linear-gradient(90deg, rgba(238, 102, 102, 1), rgba(238, 102, 102, 0.5))","margin-bottom":"10px"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode("（总资源）在表开单率"),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(totalResourceDealRate.value), 1),
                    _createTextVNode("%")
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            span: 7,
            offset: 1
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})